import { LabelColor } from "@cirrus/common/constants/label"
import { Combobox } from "@cirrus/ui-kit/src/components/molecules/index.js"
import { Chip } from "@mui/material"
import { isNilOrEmpty } from "ramda-extension"
import React from "react"
import { Field, FieldRenderProps } from "react-final-form"
import { AutocompleteFilterWrapper } from "./AutocompleteFilterWrapper"


export const AutocompleteFilter = ({
                                     multiple = false,
                                     name,
                                     onInputChange = (value) => value,
                                     optionLabel = (option) => option.title,
                                     options,
                                     renderOption = (props, option) => <li {...props}>{option.title}</li>,
                                     title,
                                     placeholder,
                                    hideLabel= false,
                                   }) => {

  const FieldContent = (field: FieldRenderProps<string>) => {
    return (
      <Combobox
        {...field}
        triggerLength={0}
        value={
          isNilOrEmpty(field.input.value)
            ? []
            : multiple
              ? field.input.value
              : [field.input.value]
        }
        onChange={(_, value) => {

          if (multiple) {
            field.input.onChange(value)
            field.input.focus?.()
            return
          }

          field.input.onChange(value[1] || value[0] || "")
        }}
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              key={index}
              variant="outlined"
              color={name === "labels" ? LabelColor[option.type] : "default"}
              label={option.title}
              {...getTagProps({ index })}
            />
          ))
        }
        onInputChange={(event) => {
          if (!event) return
          onInputChange(event.target.value)
        }}
        InputProps={{
          disableUnderline: true
        }}
        label={placeholder || title}
        placeholder={
          multiple
          && (field.input.value || []).length > 1
          && `+ ${field.input.value.length - 1}` || ""
        }
        clearOnBlur={multiple}
        forcePopupIcon={true}
        optionLabel={optionLabel}
        renderOption={renderOption}
        fullWidth
        options={options}
        multiple
        variant="filled"
        type="date"
        width="100%"
      />
    )
  }

  return (
    <AutocompleteFilterWrapper name={name} title={title} hideLabel={hideLabel}>
      <Field name={name}>{FieldContent}</Field>
    </AutocompleteFilterWrapper>
  )
}
